import { render, staticRenderFns } from "./licenses.vue?vue&type=template&id=dd715060&scoped=true"
import script from "./licenses.vue?vue&type=script&lang=js"
export * from "./licenses.vue?vue&type=script&lang=js"
import style0 from "./licenses.vue?vue&type=style&index=0&id=dd715060&prod&scoped=true&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "dd715060",
  null
  
)

export default component.exports